import { ConfirmationModal } from '../../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { useConfirmationAction } from '../../../../hooks/confirmation-action.hook';
import { useMutationCancelOrder } from '../../order-details.queries';
import { KnownOrderDtoStatus, OrderDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { mapHubToDeliveryContainerLabel } from '../order-details.utils';
import { useIsRetailFlow } from '../../../list/actions/book-order/use-booking-flow-type.hook';

export function MarkCancelledModal({
  order,
  onAbort,
  onSuccess
}: {
  order: OrderDto;
  onAbort(): void;
  onSuccess(): void;
}) {
  const { onConfirm, state } = useConfirmationAction({
    mutationHook: useMutationCancelOrder,
    mutationArgs: { retailerID: order.retailer.id, orderID: order.id },
    onSuccess,
    modalCloseDelay: 300
  });
  const isRetailFlow = useIsRetailFlow(order.retailer.id);

  return (
    <ConfirmationModal
      title="Mark Cancelled?"
      content={makeModalContent(order, isRetailFlow)}
      onConfirm={onConfirm}
      onCancel={onAbort}
      actionButton={{
        label: 'Mark Cancelled',
        color: 'danger'
      }}
      cancelButton={{
        label: 'No'
      }}
      {...state}
    />
  );
}

function makeModalContent(order: OrderDto, isRetailFlow: boolean): string[] {
  const deliveryContainerLabel = mapHubToDeliveryContainerLabel(order.hub);
  if (!isRetailFlow) {
    return ['Are you sure?'];
  }
  const content = [`Marking the order Cancelled is for when the delivery was made in error or was accidentally empty.`];
  if (assertIsIntermediateState(order.status)) {
    content[0] += ` We'll update the ${deliveryContainerLabel} state to reflect that it is now empty and the customer's collection code will no longer work.`;
    content.push(
      `If you need to take the order out of the ${deliveryContainerLabel}, you should Retrieve instead, or if it was given to the customer, mark it Collected.`
    );
  }

  content.push(`Are you sure?`);

  return content;
}

function assertIsIntermediateState(status: string) {
  return [KnownOrderDtoStatus.Delivered, KnownOrderDtoStatus.Overdue, KnownOrderDtoStatus.RetrievalRequired].includes(
    status as KnownOrderDtoStatus
  );
}
